import {createAction} from "redux-actions";

import {customerInfo} from "../../../utils/api/api-endpoint-dictionary";
import callApi from "../../../utils/api/axios";

/* Action Types */
export const CUSTOMER_INFO = 'CUSTOMER_INFO';

/* Reducers */
export default function associatedAgreements(
  state = {
    isLoading: false,
    isLoaded: false,
    hasFailed: false,
    fullName: '',
    serviceLevel: '',
    relationshipManager: null,
    webViewEnabled: window.location.host.includes('awstrp'),
  },
  { payload, type }
) {
  switch (type) {
    case `${CUSTOMER_INFO}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${CUSTOMER_INFO}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        fullName: payload.data.fullName,
        serviceLevel: payload.data.serviceLevel,
        relationshipManager: payload.data.relationshipManager,
      };

    case `${CUSTOMER_INFO}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    default:
      return state;
  }
}

export const getCustomerInfo = () => {
  return (dispatch) => {
    const action = createAction(CUSTOMER_INFO)(callApi(customerInfo));
    try {
      return dispatch(action);
    } catch (e) {
      console.error(e);
    }
  };
};
